import { createCrud } from '@sales-center/common'

export const {
  get,
  getNoRedirect,
  patch,
  put,
  post,
  remove,
  request,
  isUnexpectedResponseError,
  getAuthHeader,
  setAuthHeader,
  clearAuthHeader,
} = createCrud('authToken', '', true)

export type APIValidationError = {
  title: string
  errors?: {
    [key: string]: string[]
  }
}

export type APIError = {
  Message: string
  StatusCode: number
}

export type APIResponse = {
  status: string
  statusMessage: string
}

export type APIReject = APIError | APIValidationError

export function isAPIValidationError(obj: any): obj is APIValidationError {
  return typeof obj.title === 'string'
}

export function validationErrorsToMap(
  error: APIValidationError,
): Map<string, string[]> {
  const { errors = {} } = error
  return new Map(Object.keys(errors).map((k) => [k.toLowerCase(), errors[k]]))
}

export function isAPIError(obj: any): obj is APIError {
  return typeof obj.Message === 'string'
}
